import { createMuiTheme, Theme } from "@material-ui/core";

const theme: Theme = createMuiTheme({});

export default theme;
